export default __webpack_public_path__ + "static/media/NotoSans-Bold.85fea37f.woff2";